import moment from 'moment';

export const isPastConference = (endDate?: string | null) => {
  if (endDate) {
    return moment().isAfter(endDate, 'd');
  }
  return false;
};
